// extracted by mini-css-extract-plugin
export default {"container":"nb","hidden":"ob","column":"pb","headline":"qb"};